import { BIM360Project } from "../BIM360Project";
import { BIM360Issue } from "../BIM360Issue";
import { AutodeskDmFolder } from "../AutodeskDmFolder";

export class FrontendBIM360Project extends BIM360Project {
  public async getIssues(): Promise<BIM360Issue[]> {
    return [];
  }

  public async getFolders(): Promise<AutodeskDmFolder[]> {
    return [];
  }
}
